import { Notation, NotationType } from '@alucio/aws-beacon-amplify/src/models';
import { v4 as uuid } from 'uuid';

export function getBookmarkedPageIds(notations: readonly Notation[] = []): string[] {
  return [...new Set(notations
    .filter(notation => notation.type === NotationType.PAGE_BOOKMARK && notation.status === 'ACTIVE')
    .map(notation => notation.pageId))];
}

export function getBookmarkedPages<T extends { page: { pageId: string } }>(
  pages: readonly T[], notations: readonly Notation[],
): T[] {
  const ids = new Set(getBookmarkedPageIds(notations));
  return pages.filter(page => ids.has(page.page.pageId));
}

export function migratePageBookmarks(
  source: readonly Notation[], destination: readonly Notation[],
  mappings: Record<string, string | null | undefined>, targetPageIds: readonly string[],
): Notation[] {
  const existing = new Set(destination.filter(n => n.type === NotationType.PAGE_BOOKMARK).map(n => n.pageId));
  const targets = new Set(targetPageIds);
  const now = new Date().toISOString();
  return source.reduce<Notation[]>((result, notation) => {
    const pageId = mappings[notation.pageId];
    if (notation.type !== NotationType.PAGE_BOOKMARK || notation.status !== 'ACTIVE' ||
      !pageId || !targets.has(pageId) || existing.has(pageId)) return result;
    existing.add(pageId);
    result.push({ ...notation, id: uuid(), pageId, createdAt: now, updatedAt: now });
    return result;
  }, []);
}
